import { render, staticRenderFns } from "./Commentpro.vue?vue&type=template&id=47811c3c&scoped=true&"
import script from "./Commentpro.vue?vue&type=script&lang=js&"
export * from "./Commentpro.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/evaluation.css?vue&type=style&index=0&id=47811c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47811c3c",
  null
  
)

export default component.exports